import script from "./InLogAlma.vue?vue&type=script&lang=ts&setup=true"
export * from "./InLogAlma.vue?vue&type=script&lang=ts&setup=true"

import "./InLogAlma.vue?vue&type=style&index=0&id=ed81155a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed81155a"]])

export default __exports__